import React, { useState } from "react";
import { REGIME_TVA_OPTIONS } from "../../../../Portefeuille/regimeTvaOptions";
import { authFetch } from '../../../../../HttpClient';
import { uploadFileToBlob } from "../../../../../utils/uploadFileToBlob";

import { dialog } from "../../../../../components/ui/Dialog";
import { showStatusToast } from "../../../../../components/ui/Toast";
import {
  Building2,
  AlertCircle,
  MapPin,
  Trash2,
  Users,
  FileText,
  ChevronUp,
  ChevronDown,
  Loader2,
  Check,
} from "lucide-react";

const ModifCreationSociete = ({ item, onClose, fetchData }) => {
  const [clausesAssociesOpen, setClausesAssociesOpen] = useState(false);
  const [clausesAssociesOpen2, setClausesAssociesOpen2] = useState(false);
  const [ChaqueAssocieDocument, setChaqueAssocieDocument] = useState(false);
  const [formData, setFormData] = useState({
    formeSociale: item.formeSociale || "",
    nomSociete: item.nomSociete || "",
    siegeSocial: item.siegeSocial || "",
    typeSocial: item.typeSocial || "",
    capital: item.capital || "",
    banque: item.banque || "",
    clauseAgreement: item.clauseAgreement || false,
    clauseExclusion: item.clauseExclusion || false,
    clauseInalienabilite: item.clauseInalienabilite || false,
    clausePreemption: item.clausePreemption || false,
    clauseSortie: item.clauseSortie || false,
    autresClauses: item.autresClauses || false,
    commentaire: item.commentaire || "",
    existenceAction: item.existenceAction || false,
    quorum: item.quorum || false,
    limitation: item.limitation || false,
    autresClauses2: item.autresClauses2 || false,
    commentaire2: item.commentaire2 || "",
    regimeFiscal: item.regimeFiscal || "",
    regimeTVA: item.regimeTVA || "",
    dateCloture: item.dateCloture || "",
    acteAnterieur: item.acteAnterieur || false,
    commentaire3: item.commentaire3 || "",
    dueDate: item.dueDate ? item.dueDate.split("T")[0] : "",
    priority: item.priority || "classique",
    status: item.status || "En attente",
    coefficient: item.coefficient || "",
  });

  const [associes, setAssocies] = useState(
    item.associes && item.associes.length > 0
      ? item.associes
      : [{ nomAssocie: "", pourcentage: 0, dirigeant: false }]
  );

  const [documents, setDocuments] = useState({
    pieceId: null,
    livretFamille: item.livretFamille || null,
    carteSecurite: null,
    adressePerso: null,
    avisImposition: null,
    adressse: null,
    dernierAvisImposition: null,
    pieceIdHebergeur: null,
  });

  // const documentNames = {
  //   pieceId: " • Pièce d'identité",
  //   livretFamille: " • Livret de famille",
  //   carteSecurite:
  //     " • Carte de sécurité sociale ou attestation d’affiliation à la sécurité sociale",
  //   adressePerso: " • Justificatif d’adresse personnelle",
  //   avisImposition: "Dernier avis d’imposition aux taxes foncières",
  //   adressse:
  //     "Justificatif d’adresse de moins de 3 mois (facture d’eau, électricité, internet fixe",
  //   dernierAvisImposition:
  //     " Dernier avis d’imposition aux taxes foncières de l’hébergeur",
  //   pieceIdHebergeur: "Pièce d’identité de l’hébergeur",
  // };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAssocieChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const updated = [...associes];
    updated[index][name] = type === "checkbox" ? checked : value;
    setAssocies(updated);
  };

  const addAssocie = () => {
    setAssocies([
      ...associes,
      { nomAssocie: "", pourcentage: 0, dirigeant: false },
    ]);
  };

  const removeAssocie = (index) => {
    const updated = [...associes];
    updated.splice(index, 1);
    setAssocies(updated);
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setDocuments((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // ✅ On utilise FormData car il y a des fichiers
      const formDataToSend = new FormData();

      // Champs texte
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined)
          formDataToSend.append(key, value);
      });

      // Liste des associés (JSON)
      formDataToSend.append("associes", JSON.stringify(associes));

      // Fichiers — upload direct navigateur → Blob (contourne la limite
      // 4,5 Mo), un toast informe de la progression.
      const fileEntries = Object.entries(documents).filter(([, file]) => file);
      if (fileEntries.length > 0) {
        const uploadToast = showStatusToast({ status: "loading", titre: "Envoi du document...", message: "0 %" });
        for (const [key, file] of fileEntries) {
          const url = await uploadFileToBlob(
            file,
            "https://backend-myalfa.vercel.app/api/creation-sct/upload-token",
            ({ percentage }) =>
              uploadToast.update({ status: "loading", titre: "Envoi du document...", message: `${Math.round(percentage)} %` })
          );
          formDataToSend.append(`${key}Url`, url);
        }
        uploadToast.update({ status: "success", titre: "Document envoyé", message: "" });
      }

      const res = await authFetch(`https://backend-myalfa.vercel.app/api/creation-sct/${item.id}`,
        {
          method: "PUT",
          body: formDataToSend, // Pas besoin de header Content-Type ici
        }
      );

      const result = await res.json();
      if (!res.ok) {
        dialog.alert(
          "Erreur: " + (result?.message || "Erreur lors de la modification")
        );
        return;
      }
    } catch (error) {
      console.error(error);
      dialog.alert("Erreur lors de la modification");
    } finally {
      fetchData();
      onClose();
    }
    fetchData();
  };

  return (
    <div className="px-8 ">
      <div className="flex items-center gap-3 pb-3 border-b mt-5">
        <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center">
          <Building2 className="w-4 h-4 text-emerald-600" />
        </div>
        <h3
          className="text-lg font-semibold text-slate-900 leading-none"
          style={{ margin: 0 }}
        >
          Immatriculation
        </h3>
      </div>
      <form onSubmit={handleSubmit}>
        <br />
        <div className="bg-gradient-to-br from-[#9B1B5D]/5 via-white to-transparent rounded-xl p-5 border-2 border-[#9B1B5D]/20">
          {/* Titre */}
          <h4 className="text-sm font-bold text-[#9B1B5D] mb-4 flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Informations essentielles
          </h4>
          <div className="grid grid-cols-2 gap-4 mt-3">
            {/* Forme sociale */}
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Forme Sociale <span className="text-red-500">*</span>
              </label>

              <select
                name="formeSociale"
                value={formData.formeSociale}
                onChange={handleChange}
                className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.formeSociale
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
              >
                <option value="">Sélectionner...</option>
                {[
                  "E.I",
                  "E.I.R.L",
                  "EARL",
                  "EURL",
                  "SARL",
                  "SPFPL (SARL)",
                  "SASU",
                  "SAS",
                  "SPFPL (SAS)",
                  "SCI",
                  "SCCV",
                  "LMNP",
                  "GFA",
                  "SC",
                  "SCP",
                  "SEL",
                  "N/A",
                ].map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            {/* Capital social */}
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Capital social <span className="text-red-500">*</span>
              </label>

              <input
                name="capital"
                type="text"
                value={formData.capital}
                onChange={handleChange}
                placeholder="Ex : 10 000 €"
                className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.capital
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 mt-3">
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Régime Fiscal <span className="text-red-500">*</span>
              </label>
              <select
                name="regimeFiscal"
                type="text"
                value={formData.regimeFiscal}
                onChange={handleChange}
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.regimeFiscal
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              >
                <option value="">Sélectionner...</option>
                {[
                  "IS RS",
                  "IS RN",
                  "IR BIC Micro",
                  "IR BIC RS",
                  "IR BIC RN",
                  "IR BNC micro",
                  "IR BNC réel",
                  "IR RF",
                  "IR LMNP",
                ].map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Régime TVA <span className="text-red-500">*</span>
              </label>
              <select
                name="regimeTVA"
                type="text"
                value={formData.regimeTVA}
                onChange={handleChange}
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.regimeTVA
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              >
                <option value="">Sélectionner...</option>
                {REGIME_TVA_OPTIONS.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mt-3">
            <label className="text-sm font-medium text-slate-700">
              Dénomination sociale
            </label>
            <input
              className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.nomSociete
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              name="nomSociete"
              type="text"
              value={formData.nomSociete}
              onChange={handleChange}
              placeholder="Raison sociale..."
            />
          </div>
          <div className="mt-3">
            <label className="text-sm font-medium text-slate-700">
              Nom commercial (optionnel)
            </label>
            <input
              className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.nomCommercial
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
              name="nomCommercial"
              type="text"
              value={formData.nomCommercial}
              onChange={handleChange}
              placeholder="Raison sociale..."
            />
          </div>
        </div>

        <div className="mt-3">
          <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
            Banque
          </label>
          <select
            name="banque"
            value={formData.banque}
            onChange={handleChange}
            className={`
        mt-2
        h-11
        w-full
        rounded-md
        bg-white
        px-3
        text-sm
        border-2
        outline-none
        transition-all
        ${
          formData.banque
            ? "border-emerald-300 focus:border-emerald-400"
            : "border-slate-300 focus:border-slate-400"
        }
      `}
          >
            <option value="">-- Sélectionner --</option>
            {[
              "Crédit Agricole",
              "BNP Paribas",
              "Société Générale",
              "LCL",
              "Caisse d'Épargne",
              "Banque Populaire",
              "CIC",
              "Crédit Mutuel",
              "La Banque Postale",
              "HSBC",
              "Boursorama",
              "Fortuneo",
              "Hello bank!",
              "N26",
              "Revolut",
              "Qonto",
              "Shine",
              "Autre",
            ].map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
        <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 mt-4">
          <label className="text-sm font-semibold flex items-center gap-2 mb-3">
            <MapPin className="w-4 h-4 text-slate-500" />
            Siège social
          </label>
          <div className="grid grid-cols-[1fr_auto] gap-3">
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Siège Social
              </label>
              <input
                name="siegeSocial"
                type="text"
                value={formData.siegeSocial}
                onChange={handleChange}
                className={`
                          mt-2
                          h-11
                          w-full
                          rounded-md
                          bg-white
                          px-3
                          text-sm
                          border-2
                          outline-none
                          transition-all
                          ${
                            formData.siegeSocial
                              ? "border-emerald-300 focus:border-emerald-400"
                              : "border-slate-300 focus:border-slate-400"
                          }
                        `}
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Type de siège social
              </label>

              <select
                name="typeSocial"
                value={formData.typeSocial}
                onChange={handleChange}
                className={`
              mt-2
              h-11
              w-full
              rounded-md
              bg-white
              px-3
              text-sm
              border-2
              outline-none
              transition-all
              ${
                formData.typeSocial
                  ? "border-emerald-300 focus:border-emerald-400"
                  : "border-slate-300 focus:border-slate-400"
              }
            `}
              >
                <option value="">Sélectionner...</option>
                {[
                  "Propriétaire",
                  "Locataire",
                  "Hébergé à titre gratuit",
                  "Domiciliation",
                  "Autre",
                ].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-3">
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Complément d'adresse
              </label>
              <input
                name="adresse_complement"
                type="text"
                value={formData.adresse_complement}
                onChange={handleChange}
                className={`
                          mt-2
                          h-11
                          w-full
                          rounded-md
                          bg-white
                          px-3
                          text-sm
                          border-2
                          outline-none
                          transition-all
                          ${
                            formData.adresse_complement
                              ? "border-emerald-300 focus:border-emerald-400"
                              : "border-slate-300 focus:border-slate-400"
                          }
                        `}
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Code Postal
              </label>
              <input
                name="codePostal"
                type="text"
                value={formData.codePostal}
                onChange={handleChange}
                className={`
                          mt-2
                          h-11
                          w-full
                          rounded-md
                          bg-white
                          px-3
                          text-sm
                          border-2
                          outline-none
                          transition-all
                          ${
                            formData.codePostal
                              ? "border-emerald-300 focus:border-emerald-400"
                              : "border-slate-300 focus:border-slate-400"
                          }
                        `}
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
                Ville
              </label>
              <input
                name="ville"
                type="text"
                value={formData.ville}
                onChange={handleChange}
                className={`
                          mt-2
                          h-11
                          w-full
                          rounded-md
                          bg-white
                          px-3
                          text-sm
                          border-2
                          outline-none
                          transition-all
                          ${
                            formData.ville
                              ? "border-emerald-300 focus:border-emerald-400"
                              : "border-slate-300 focus:border-slate-400"
                          }
                        `}
              />
            </div>
          </div>
        </div>
        <div className="mt-4 bg-slate-50 rounded-xl p-4 border border-slate-200">
          {/* Header */}
          <div className="flex items-center justify-between mb-3">
            <label className="text-sm font-semibold flex items-center gap-2">
              <Users className="w-4 h-4 text-slate-500" />
              Associés
            </label>
            <button
              type="button"
              onClick={addAssocie}
              className="
                h-8
                px-3
                rounded-md
                bg-[#9B1B5D]
                text-white
                text-xs
                font-medium
                hover:bg-[#7A1548]
                transition-colors
              "
            >
              + Ajouter
            </button>
          </div>

          {/* Header grid */}
          <div className="grid [grid-template-columns:2fr_2fr_2fr_80px_60px_40px] gap-2 mb-2 text-xs font-medium text-slate-600">
            <div>Nom</div>
            <div>Email</div>
            <div>Téléphone</div>
            <div className="text-center">Part %</div>
            <div className="text-center">Dirigeant</div>
            <div></div>
          </div>

          {/* Rows */}
          {associes.map((associe, index) => (
            <div
              key={index}
              className="grid [grid-template-columns:2fr_2fr_2fr_80px_60px_40px] gap-2 mb-2 items-center"
            >
              {/* Nom */}
              <input
                name="nomAssocie"
                value={associe.nomAssocie}
                onChange={(e) => handleAssocieChange(index, e)}
                placeholder="Nom associé"
                className="
                  h-9
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border
                  border-slate-300
                  outline-none
                  focus:border-emerald-400
                "
              />
              <input
                name="emailAssocie"
                value={associe.emailAssocie}
                onChange={(e) => handleAssocieChange(index, e)}
                placeholder="Email associé"
                className="
                  h-9
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border
                  border-slate-300
                  outline-none
                  focus:border-emerald-400
                "
              />
              <input
                name="telephoneAssocie"
                value={associe.telephoneAssocie}
                onChange={(e) => handleAssocieChange(index, e)}
                placeholder="Téléphone associé"
                className="
                  h-9
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border
                  border-slate-300
                  outline-none
                  focus:border-emerald-400
                "
              />
              {/* Pourcentage */}
              <input
                name="pourcentage"
                type="number"
                value={associe.pourcentage}
                onChange={(e) => handleAssocieChange(index, e)}
                placeholder="%"
                className="
                  h-9
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border
                  border-slate-300
                  outline-none
                  focus:border-emerald-400
                "
              />
              {/* Dirigeant */}
              <div className="flex justify-center">
                <input
                  name="dirigeant"
                  type="checkbox"
                  checked={associe.dirigeant}
                  onChange={(e) => handleAssocieChange(index, e)}
                  className="h-4 w-4 accent-[#9B1B5D]"
                />
              </div>
              {/* Actions */}
              <button
                type="button"
                onClick={() => removeAssocie(index)}
                className="
                  h-8
                  w-8
                  flex
                  items-center
                  justify-center
                  rounded-md
                  hover:bg-red-50
                  text-red-600
                  text-xs
                  transition-colors
                "
              >
                <Trash2 className="w-3 h-3 text-red-600" />
              </button>
            </div>
          ))}
        </div>

        <br />
        <div className="mt-0 bg-slate-50 rounded-xl border border-slate-200">
          {/* Trigger */}
          <div className="w-full flex items-center justify-between p-3 hover:bg-slate-100 transition-colors rounded-t-xl">
            {/* Titre */}
            <span className="text-sm font-semibold flex items-center gap-2">
              <FileText className="w-4 h-4 text-slate-500" />
              Clauses relatives aux associés
            </span>

            {/* Oui / Non + Chevron */}
            <div className="flex items-center gap-4">
              {/* Oui / Non */}
              <div
                className="flex items-center gap-2 text-sm text-slate-600"
                onClick={(e) => e.stopPropagation()} // ⚡ stop la propagation pour pas fermer le collapsible
              >
                <label className="flex items-center gap-1 cursor-pointer">
                  <input
                    type="radio"
                    name="acteAnterieur"
                    value="true"
                    checked={formData.acteAnterieur === true}
                    onChange={() =>
                      handleChange({
                        target: { name: "acteAnterieur", value: true },
                      })
                    }
                    className="h-4 w-4 accent-[#9B1B5D]"
                  />
                  Oui
                </label>

                <label className="flex items-center gap-1 cursor-pointer">
                  <input
                    type="radio"
                    name="acteAnterieur"
                    value="false"
                    checked={formData.acteAnterieur === false}
                    onChange={() =>
                      handleChange({
                        target: { name: "acteAnterieur", value: false },
                      })
                    }
                    className="h-4 w-4 accent-[#9B1B5D]"
                  />
                  Non
                </label>
              </div>

              {/* Chevron */}
              <button
                type="button"
                onClick={() => setClausesAssociesOpen(!clausesAssociesOpen)}
                className="flex items-center justify-center text-slate-500"
              >
                {clausesAssociesOpen ? (
                  <ChevronUp className="w-4 h-4" />
                ) : (
                  <ChevronDown className="w-4 h-4" />
                )}
              </button>
            </div>
          </div>

          {/* Contenu */}
          {clausesAssociesOpen && (
            <div className="p-4 space-y-3">
              {/* Checkboxes */}
              <div className="grid grid-cols-2 gap-3">
                {[
                  { name: "clauseAgreement", label: "Clause d'agrément" },
                  { name: "clauseExclusion", label: "Clause d'exclusion" },
                  {
                    name: "clauseInalienabilite",
                    label: "Clause d'inaliénabilité",
                  },
                  { name: "clausePreemption", label: "Clause de préemption" },
                  { name: "clauseSortie", label: "Clause Sortie" },
                  { name: "autresClauses", label: "Autres" },
                ].map(({ name, label }) => (
                  <label
                    key={name}
                    className="flex items-center gap-2 bg-white p-2 rounded-lg border border-slate-200 hover:border-[#9B1B5D]/30 transition-colors cursor-pointer text-sm"
                  >
                    <input
                      type="checkbox"
                      name={name}
                      checked={formData[name]}
                      onChange={handleChange}
                      className="h-4 w-4 accent-[#9B1B5D]"
                    />
                    {label}
                  </label>
                ))}
              </div>

              {/* Commentaire */}
              <div>
                <textarea
                  name="commentaire"
                  rows={4}
                  value={formData.commentaire}
                  onChange={handleChange}
                  placeholder="Précisions..."
                  className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
                />
              </div>
            </div>
          )}
        </div>
        <br />

        <div className="mt-0 bg-slate-50 rounded-xl border border-slate-200">
          {/* Trigger */}
          <button
            type="button"
            onClick={() => setClausesAssociesOpen2(!clausesAssociesOpen2)}
            className="w-full p-3 flex items-center justify-between hover:bg-slate-100 transition-colors rounded-t-xl"
          >
            <span className="text-sm font-semibold flex items-center gap-2">
              <FileText className="w-4 h-4 text-slate-500" />
              Clauses relatives à la gouvernance
            </span>

            <span className="text-slate-500">
              {clausesAssociesOpen2 ? (
                <ChevronUp className="w-4 h-4 text-slate-500" />
              ) : (
                <ChevronDown className="w-4 h-4 text-slate-500" />
              )}
            </span>
          </button>

          {/* Contenu */}
          {clausesAssociesOpen2 && (
            <div className="p-4 space-y-3">
              {/* Checkboxes */}
              <div className="grid grid-cols-2 gap-3">
                {[
                  {
                    name: "existenceAction",
                    label: "Existence d'action de préférence",
                  },
                  { name: "quorum", label: "Quorum ou majorité renforcée" },
                  {
                    name: "limitation",
                    label: "Limitation des pouvoirs du dirigeant",
                  },
                  { name: "autresClauses2", label: "Autres" },
                ].map(({ name, label }) => (
                  <label
                    key={name}
                    className="flex items-center gap-2 bg-white p-2 rounded-lg border border-slate-200 hover:border-[#9B1B5D]/30 transition-colors cursor-pointer text-sm"
                  >
                    <input
                      type="checkbox"
                      name={name}
                      checked={formData[name]}
                      onChange={handleChange}
                      className="h-4 w-4 accent-[#9B1B5D]"
                    />
                    {label}
                  </label>
                ))}
              </div>

              {/* Commentaire */}
              <div>
                <label className="text-sm font-medium text-slate-700 mb-1 block">
                  Commentaire :
                </label>
                <textarea
                  name="commentaire2"
                  rows={4}
                  value={formData.commentaire2}
                  onChange={handleChange}
                  placeholder="Précisions..."
                  className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
                />
              </div>
            </div>
          )}
        </div>

        <div>
          <label className="text-sm font-semibold text-slate-700 flex items-center gap-1 mt-8">
            Date de clôture
          </label>
          <input
            name="dateCloture"
            type="date"
            value={formData.dateCloture}
            onChange={handleChange}
            className={`
                      mt-2
                      h-11
                      w-full
                      rounded-md
                      bg-white
                      px-3
                      text-sm
                      border-2
                      outline-none
                      transition-all
                      ${
                        formData.dateCloture
                          ? "border-emerald-300 focus:border-emerald-400"
                          : "border-slate-300 focus:border-slate-400"
                      }
                    `}
          />
        </div>
        {/* <div style={{ display: "flex", flexDirection: "row", gap: "10%" }}>
                  <label>Commentaire :</label>
                  <textarea
                    style={{ width: "70%" }}
                    name="commentaire3"
                    type="text"
                    value={formData.commentaire3}
                    onChange={handleChange}
                    rows={8}
                  />
                </div>{" "} */}
        {/* 
                <div style={{ display: "flex", flexDirection: "row", gap: "10%" }}>
                  <label>Commentaire Activité :</label>
                  <textarea
                    style={{ width: "70%" }}
                    name="activite"
                    type="text"
                    value={formData.activite}
                    onChange={handleChange}
                    rows={8}
                  />
                </div>{" "} */}
        <div className="grid grid-cols-4 gap-3 mt-5">
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Echéance{" "}
            </label>
            <input
              name="dueDate"
              type="date"
              value={formData.dueDate}
              onChange={handleChange}
              className={`
                        mt-2
                        h-11
                        w-full
                        rounded-md
                        bg-white
                        px-3
                        text-sm
                        border-2
                        outline-none
                        transition-all
                        ${
                          formData.dueDate
                            ? "border-emerald-300 focus:border-emerald-400"
                            : "border-slate-300 focus:border-slate-400"
                        }
                      `}
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Priorité
            </label>
            <select
              name="priority"
              value={formData.priority}
              onChange={handleChange}
              className={`
                        mt-2
                        h-11
                        w-full
                        rounded-md
                        bg-white
                        px-3
                        text-sm
                        border-2
                        outline-none
                        transition-all
                        ${
                          formData.priority
                            ? "border-emerald-300 focus:border-emerald-400"
                            : "border-slate-300 focus:border-slate-400"
                        }
                      `}
            >
              <option value="classique">Classique</option>
              <option value="élevé">Élevé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Status
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={`
                        mt-2
                        h-11
                        w-full
                        rounded-md
                        bg-white
                        px-3
                        text-sm
                        border-2
                        outline-none
                        transition-all
                        ${
                          formData.status
                            ? "border-emerald-300 focus:border-emerald-400"
                            : "border-slate-300 focus:border-slate-400"
                        }
                      `}
            >
              <option value="En attente">En attente</option>
              <option value="En attente informations / documents">
                En attente informations / documents
              </option>
              <option value="En attente interne">En attente interne</option>
              <option value="Dépôt de capital en cours">
                Dépôt de capital en cours
              </option>
              <option value="Rédaction">Rédaction</option>
              <option value="Supervision">Supervision</option>
              <option value="Signature">Signature</option>
              <option value="Signature en cours">Signature en cours</option>
              <option value="Formalité">Formalité</option>
              <option value="Formalité déposée">Formalité déposée</option>
              <option value="Formalité à régulariser">
                Formalité à régulariser
              </option>
              <option value="Formalité rejetée">Formalité rejetée</option>
              <option value="Bloqué">Bloqué</option>
              <option value="Abandonné">Abandonné</option>
              <option value="Terminé">Terminé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Coefficient
            </label>
            <input
              name="coefficient"
              type="text"
              value={formData.coefficient}
              onChange={handleChange}
              className={`
                        mt-2
                        h-11
                        w-full
                        rounded-md
                        bg-white
                        px-3
                        text-sm
                        border-2
                        outline-none
                        transition-all
                        ${
                          formData.coefficient
                            ? "border-emerald-300 focus:border-emerald-400"
                            : "border-slate-300 focus:border-slate-400"
                        }
                      `}
            />
          </div>
        </div>

        <div className="mt-6 bg-slate-50 rounded-xl border border-slate-200">
          {/* Trigger */}
          <button
            type="button"
            onClick={() => setChaqueAssocieDocument(!ChaqueAssocieDocument)}
            className="w-full p-3 flex items-center justify-between hover:bg-slate-100 transition-colors rounded-t-xl"
          >
            <span className="text-sm font-semibold flex items-center gap-2">
              <FileText className="w-4 h-4 text-slate-500" />
              Documents à obtenir pour chaque associé
            </span>

            <span className="text-slate-500">
              {ChaqueAssocieDocument ? (
                <ChevronUp className="w-4 h-4 text-slate-500" />
              ) : (
                <ChevronDown className="w-4 h-4 text-slate-500" />
              )}
            </span>
          </button>

          {/* Contenu */}
          {ChaqueAssocieDocument && (
            <div className="p-4 space-y-4">
              {/* Pièces générales */}
              <div>
                <p className="font-medium text-slate-700 mb-2">Cas général :</p>
                <div className="space-y-2 ml-4">
                  {[
                    { label: "Pièce d’identité", name: "pieceId" },
                    { label: "Livret de famille", name: "livretFamille" },
                    {
                      label: "Carte de sécurité sociale / attestation",
                      name: "carteSecurite",
                    },
                    {
                      label: "Justificatif d’adresse personnelle",
                      name: "adressePerso",
                    },
                  ].map(({ label, name }) => (
                    <div key={name} className="flex items-center gap-3">
                      <span className="text-sm text-slate-700">{label}</span>
                      <input
                        type="file"
                        name={name}
                        onChange={handleFileChange}
                        className="text-sm text-slate-600"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Pièces selon situation */}
              <div className="ml-4 space-y-2">
                {/* Propriétaire */}
                <p className="font-medium text-slate-700">Si propriétaire :</p>
                <div className="flex items-center gap-3 ml-4">
                  <span className="text-sm text-slate-700">
                    Dernier avis d’imposition aux taxes foncières
                  </span>
                  <input
                    type="file"
                    name="avisImposition"
                    onChange={handleFileChange}
                    className="text-sm text-slate-600"
                  />
                </div>

                {/* Locataire */}
                <p className="font-medium text-slate-700 mt-2">
                  Si locataire :
                </p>
                <div className="flex items-center gap-3 ml-4">
                  <span className="text-sm text-slate-700">
                    Justificatif d’adresse supérieur inférieur 3 mois (facture
                    d’eau, électricité, internet fixe)
                  </span>
                  <input
                    type="file"
                    name="adressse"
                    onChange={handleFileChange}
                    className="text-sm text-slate-600"
                  />
                </div>

                {/* Hébergé */}
                <p className="font-medium text-slate-700 mt-2">Si hébergé :</p>
                <div className="space-y-2 ml-4">
                  <div className="flex items-center gap-3">
                    <span className="text-sm text-slate-700 w-3/4">
                      Dernier avis d’imposition ou justificatif d’adresse
                      inférieur à 3 mois
                    </span>
                    <input
                      type="file"
                      name="dernierAvisImposition"
                      onChange={handleFileChange}
                      className="text-sm text-slate-600"
                    />
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-sm text-slate-700 w-3/4">
                      Pièce d’identité de l’hébergeur
                    </span>
                    <input
                      type="file"
                      name="pieceIdHebergeur"
                      onChange={handleFileChange}
                      className="text-sm text-slate-600"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <br />

        <div className="sticky bottom-0 bg-white border-t mt-4 px-8 py-4 flex items-center justify-between">
          <button
            type="button"
            variant="outline"
            onClick={onClose}
            className={`
              px-8
              h-11
              border-2
              border-slate-300
              text-slate-700
              rounded-md
              font-medium
              hover:bg-slate-100
              transition-colors
            `}
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`
              w-1/2
              h-11
              bg-[#9B1B5D]
              hover:bg-[#7A1548]
              text-white
              text-base
              font-medium
              rounded-md
              shadow-lg shadow-[#9B1B5D]/20
              transition-colors
              flex items-center justify-center
              gap-2
            `}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                Modification en cours...
              </>
            ) : (
              <>
                <Check className="w-5 h-5 mr-2" />
                Modifier la mission
              </>
            )}
          </button>
        </div>

        <br />
      </form>
    </div>
  );
};

export default ModifCreationSociete;
